import axios from "axios"
export function putApplicationUnderReview(userId, token, fname, email) {
    return axios.get(process.env.REACT_APP_API_URL + `/putApplicationUnderReview?userId=${userId}&fname=${fname}&email=${email}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}